import React from "react";
import Link from "next/link";
import { motion } from "framer-motion";

interface LinkProps {
  href: string;
  as?: string;
  bgColor?: string;
  color?: string;
}

interface BottomBorderProps {
  bgColor: string;
  variants: { [key: string]: any };
}
const AnimatedBottomBorder: React.FC<BottomBorderProps> = ({
  bgColor,
  variants,
}) => {
  return (
    <motion.div
      variants={variants}
      className={`absolute bottom-0 left-0 h-px ${
        bgColor ? bgColor : "bg-black"
      }`}
    />
  );
};

const borderAnimations = {
  initial: {
    right: "110%",
  },
  hovered: {
    right: "0%",
  },
};

const BorderBottomLink: React.FC<LinkProps> = ({
  children,
  href,
  as,
  bgColor,
  color,
  ...props
}) => {
  const noLinkContent = (
    <motion.div
      className="relative w-max"
      initial="initial"
      whileHover="hovered"
    >
      <p className="">{children}</p>
      <div
        className={`absolute bottom-0 right-0 left-0 opacity-30 h-px ${
          bgColor ? bgColor : "bg-black"
        }`}
      />
      <AnimatedBottomBorder
        variants={borderAnimations}
        bgColor={bgColor || "bg-black"}
      />
    </motion.div>
  );
  const content = (
    <motion.div
      className="relative w-max"
      initial="initial"
      whileHover="hovered"
    >
      <a href={href} className={`${color ? color : ""} hover:no-underline`}>
        {children}
        <div
          className={`absolute bottom-0 right-0 left-0 opacity-30 h-px ${
            bgColor ? bgColor : "bg-black"
          }`}
        />
        <AnimatedBottomBorder
          variants={borderAnimations}
          bgColor={bgColor || "bg-black"}
        />
      </a>
    </motion.div>
  );
  if (!href) {
    return noLinkContent;
  } else if (
    href.includes("mailto") ||
    href.includes("http://") ||
    href.includes("https://")
  ) {
    return content;
  }
  return (
    <Link href={href} as={as}>
      {content}
    </Link>
  );
};

export default BorderBottomLink;
